<div *ngFor="let article of articles">
  <kb-article [article]="article"></kb-article>
</div>
